import { SPSELECTS } from "InterfacesTypes/enums";
import type { IHowTo } from "InterfacesTypes/interfaces";
import type { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { fetchFailure, fetchStart, fetchSuccess, fetchHowTos } from "state/reducers/HowTosReducer";
import { spGet } from "utils/SharepointAPI";
import { getEnvironment } from "utils/utils";

const env = getEnvironment();
function* getHowTosWorker(): SagaIterator {
    try {
        yield put(fetchStart());
        const howTosUrl = `${env.listapi}/GetByTitle('HowToDescriptions')/Items?$top=5000&$select=${SPSELECTS.HOWTOS}`;
        const data: IHowTo[] = yield call(spGet, howTosUrl);
        yield put(fetchSuccess(data));
    } catch (err: any) {
        yield put(fetchFailure(err?.message ?? "Något gick fel i howTo sagan"));
    }
}

export function* howTosSaga() {
    yield takeLatest(
        fetchHowTos.type,
        getHowTosWorker
    )
}